import { logger } from '@vista/omnichannel-components-domain';
import { defaultQuickNavigatorDropdownSelectionsState } from '../types/state';
import { QuickNavigatorActionType as ActionType } from './action-type';
export const quickNavigatorActionReducer = (state, action) => {
    switch (action.type) {
        case ActionType.SetSelectedValue: {
            const { selectedValue, dropdownType } = action;
            return Object.assign(Object.assign({}, state), { dropdownSelections: Object.assign(Object.assign({}, state.dropdownSelections), { [dropdownType]: selectedValue }) });
        }
        case ActionType.ResetDropdownSelections: {
            return Object.assign(Object.assign({}, state), { dropdownSelections: defaultQuickNavigatorDropdownSelectionsState });
        }
        default: {
            logger.error(`Unknown QuickNavigatorAction ${action.type}.`);
            return state;
        }
    }
};
